// extracted by mini-css-extract-plugin
module.exports = {"displayLineBreak":"NoSearchResult_displayLineBreak__1R9LM"};